module.exports = __webpack_public_path__ + "8a273a54272f759bad98dc23d36d8ca3.svg";